import { render, staticRenderFns } from "./HomeCurrentNews.vue?vue&type=template&id=fb33dfc0&scoped=true"
import script from "./HomeCurrentNews.vue?vue&type=script&lang=js"
export * from "./HomeCurrentNews.vue?vue&type=script&lang=js"
import style0 from "./HomeCurrentNews.vue?vue&type=style&index=0&id=fb33dfc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb33dfc0",
  null
  
)

export default component.exports